export enum VerificationStatus {
  Empty,
  Automatic,
  Verified
}
